import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求标签列表
export const gettagList = params => {
    return get("/admin/evaluateTag", params);
};
// // 添加权限
export const addTag = params => {
    return post("/admin/evaluateTag", params);
};
// 修改信息
export const editTag = params => {
    return put(`/admin/evaluateTag/${params.id}`, params);
};
// 删除权限
export const deleteTag = params => {
    return del(`/admin/evaluateTag/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/personTag.js